<script>
import { MapAgentStationStatus, MapRoles } from "@/common/util";
import PagenationContainer from "@/components/common/PagenationContainer.vue";

import cloneDeep from "lodash/cloneDeep";
import forOwn from "lodash/forOwn";
import moment from "moment";
export default {
  components: {
    PagenationContainer
  },
  data() {

    var tmpSearchForm = {
        staffId: undefined,
        name: undefined,
        phone: undefined,
        role: undefined
      };
    var s = sessionStorage.getItem("salesSearchForm");
    if (s) {
      tmpSearchForm = JSON.parse(s);
    }
    // console.log(tmpSearchForm);

    var tmpPage = 1;
    var p = sessionStorage.getItem("salesPage");
    if (p) {
      tmpPage = JSON.parse(p);
    }

    return {
      searchFormData: tmpSearchForm,
      tableData: [],
      searchArray: [
        // {
        //   label: "工号",
        //   keyName: "staffId",
        //   value: tmpSearchForm.staffId,
        //   type: "text"
        // },
        {
          label: "姓名",
          keyName: "name",
          value: tmpSearchForm.name,
          type: "text"
        },
        {
          label: "联系电话",
          keyName: "phone",
          value: tmpSearchForm.phone,
          type: "text"
        },
        {
          label: "角色",
          keyName: "role",
          value: tmpSearchForm.role,
          type: "select",
          children: [
            {
              label: "全部",
              keyName: ""
            },
            {
              label: "视光师",
              keyName: "ROLE_AGENT_OPTOMETRIST"
            },
            {
              label: "医生",
              keyName: "ROLE_DOCTOR"
            },
            {
              label: '主管',
              keyName: 'ROLE_STATION_MANAGER'
            }
          ]
        }
      ],
      defaultValue: {},
      agentList: [],
      pageCount: 0,
      activePage: tmpPage,
      totalElements: 0,
      dateRange: undefined,
      buttonArray: [
        {
          text: "最近一周",
          key: "week"
        },
        {
          text: "最近30天",
          key: "month"
        },
        {
          text: "最近90天",
          key: "ninety"
        }
      ]
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      let params = {
        page: this.activePage - 1
      };
      for (let key in this.searchFormData) {
        if (this.searchFormData[key]) {
          params[key] = this.searchFormData[key];
        }
      }

      if (this.dateRange && this.dateRange[0]) {
        params.start = this.dateRange[0];
      }
      if (this.dateRange && this.dateRange[1]) {
        params.end = this.dateRange[1];
      }

      sessionStorage.setItem("salesSearchForm", JSON.stringify(this.searchFormData));
      sessionStorage.setItem("salesPage", JSON.stringify(this.activePage));

      const result = await this.$http.GetSalesPerformance(params);
      if (result && result.content) {
        this.pageCount = result.totalPages;
        this.totalElements = result.totalElements;

        const tableData = result.content.map(o => {
          let temp = [];
          if (o.roles.indexOf("ROLE_AGENT_OPTOMETRIST") >= 0) {
            temp.push("视觉训练师");
          }
          if (o.roles.indexOf("ROLE_DOCTOR") >= 0) {
            temp.push("医生");
          }
          if (o.roles.indexOf("ROLE_AGENT_FINANCIAL") >= 0) {
            temp.push("财务");
          }
          if (o.roles.indexOf("ROLE_STATION_MANAGER") >= 0) {
            temp.push("主管");
          }
          o.role = temp.join(",");
          o.totalPrice = `${o.totalSalesAmount} 元`;
          return o;
        });
        this.tableData = tableData;
      }
    },
    onSearch(data) {
      // console.log("onSearch", data);
      this.activePage = 1;
      this.loadData();
    },
    onSearchChange(data) {
      // console.log("onSearchChange", data);
      this.searchFormData = data;
    },
    onClick(row) {
      this.$router.push({
        path: `${this.$route.path}/salesManagementDetail/${row.subordinateId}`
      });
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.activePage = val;
      this.loadData();
    },
    onOperationClick(row, key) {
      console.log("key", key);
      switch (key) {
        case "month":
          this.dateRange = [
            moment()
              .subtract(30, "days")
              .format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          ];
          break;
        case "ninety":
          this.dateRange = [
            moment()
              .subtract(90, "days")
              .format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          ];
          break;
        case "week":
          this.dateRange = [
            moment()
              .subtract(6, "days")
              .format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          ];
          break;
      }
      console.log("key", this.dateRange);
    }
  }
};
</script>
<template>
  <div class="salesManagemmentIndex">
    <searchFormNew
      class="searchForm"
      showSearch
      @onSearch="onSearch"
      @onChange="onSearchChange"
      :searchItemArray="searchArray"
    />
    <div class="TextGroup">
      <div class="dataSearch">
        <span>销售疗程时间筛选：</span>
        <el-date-picker
          v-model="dateRange"
          size="medium"
          class="dateRange"
          type="daterange"
          range-separator="至"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
        <textButtonGroup
          class="dataButton"
          :buttonArray="buttonArray"
          @onOperationClick="onOperationClick"
        />
      </div>
    </div>
    <div class="statistics">
      <i class="el-icon-info totalResult"></i>
      查询结果：
      <span class="totalResult">{{totalElements}}</span> 个
    </div>
    <el-table
      :data="tableData"
      class="refundTable"
      @row-click="onClick"
      :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
      :cell-style="{'padding-left': '5px'}"
    >
      <!-- <el-table-column prop="staffId" align="left" label="工号" width="150"></el-table-column> -->
      <el-table-column prop="name" align="left" label="姓名" width="150"></el-table-column>
      <el-table-column prop="phone" align="left" label="联系电话" width="150"></el-table-column>
      <el-table-column prop="role" align="left" label="角色" width="150"></el-table-column>
      <el-table-column prop="totalSalesCourse" align="left" label="销售总疗程" width="150"></el-table-column>
      <el-table-column prop="totalPrice" align="left" label="销售总金额" min-width="150"></el-table-column>
    </el-table>
    <PagenationContainer v-if="pageCount > 1">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="activePage"
        :page-count="pageCount"
        layout="prev, pager, next, jumper"
      ></el-pagination>
    </PagenationContainer>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.salesManagemmentIndex {
  .searchForm {
    border: 1px;
    line-height: 50px;
    padding-top: 15px;
    margin: 0 1%;
  }
  .statistics {
    float: right;
    margin-right: 30px;
    margin-top: 20px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    line-height: 22px;
    .totalResult {
      color: #00c1de;
    }
  }
  .TextGroup {
    margin: 0 20px 0px;
    display: inline-block;
    font-size: 14px;
    font-weight: 400;
    color: #606266;
    .dateRange {
      width: 250px;

      .el-range-editor--mini.el-input__inner {
        height: 32px;
      }

      .el-range-editor.is-active,
      .el-range-editor.is-active:hover {
        border-color: #00c1de;
      }

      .el-date-table td.today span {
        color: #00c1de;
      }
    }
    .dataButton {
      margin-left: 10px;
      display: inline-block;
    }
  }
  .refundTable {
    margin: 20px 1%;
    border: 1px;
    width: 98%;

    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    th > .cell {
      font-weight: bold;
    }

    .cellButtonGroup {
      background-color: #00c1de;
      border-color: #00c1de;
      margin-left: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/salesManagement/index.vue